// 版本本地存储键名
export const VERSION_CHECK_KEY = 'app_version_check'
// 提示计数键名
export const VERSION_PROMPT_COUNT_KEY = 'app_version_prompt_count'
// 获取当前应用版本
import { version } from '../../package.json'
export const CURRENT_VERSION = version

// 默认最大提示次数
export const DEFAULT_MAX_PROMPTS = 1

/**
 * 比较两个版本号
 * @param versionA 版本A
 * @param versionB 版本B
 * @returns 如果A>B返回1，如果A<B返回-1，如果A=B返回0
 */
export function compareVersions(versionA: string, versionB: string): number {
  const partsA = versionA.split('.').map(Number)
  const partsB = versionB.split('.').map(Number)

  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    const partA = partsA[i] || 0
    const partB = partsB[i] || 0

    if (partA > partB) return 1
    if (partA < partB) return -1
  }

  return 0
}

/**
 * 检查版本并提示用户更新
 * @param serverVersion 服务器版本
 * @param maxPrompts 最大提示次数，默认为1次
 * @returns 是否需要更新
 */
export function checkVersion(serverVersion: string, maxPrompts = DEFAULT_MAX_PROMPTS): boolean {
  // 如果服务器版本大于当前版本，提示用户刷新
  if (compareVersions(serverVersion, CURRENT_VERSION) > 0) {
    // 检查是否已经提示过并确认
    const versionCheck = localStorage.getItem(VERSION_CHECK_KEY)

    // 如果已确认过当前版本，不再提示
    if (versionCheck === serverVersion) {
      return false
    }

    // 获取当前提示次数
    let promptCount = 0
    try {
      // 使用 sessionStorage 替代 localStorage，应用关闭时会自动清除
      promptCount = parseInt(sessionStorage.getItem(VERSION_PROMPT_COUNT_KEY) || '0', 10)
    } catch (e) {
      promptCount = 0
    }

    // 如果提示次数未达到最大值，则提示
    if (promptCount < maxPrompts) {
      // 增加提示次数
      sessionStorage.setItem(VERSION_PROMPT_COUNT_KEY, String(promptCount + 1))

      // 显示提示信息
      if (window.confirm(`新版本更新啦，建议刷新页面以获取最新功能和修复。是否立即刷新？`)) {
        // 用户点击确认，保存版本信息并刷新
        localStorage.setItem(VERSION_CHECK_KEY, serverVersion)
        window.location.reload()
        return true
      }
      // 用户点击取消，不保存版本信息
    }
  } else {
    // 如果当前版本已是最新，重置提示计数
    sessionStorage.removeItem(VERSION_PROMPT_COUNT_KEY)
  }
  return false
}
